import React from "react";
import { pathConstant } from "../../constants/index";
import history from "../../managers/history";
import PropTypes from "prop-types";

const RewardPopup = ({ handleClose }) => {
  const { CONSENT, CONSENT_REWARD } = pathConstant;
  const redirectToRewardScreen = () => {
    handleClose();
    history.push(CONSENT + CONSENT_REWARD);
  };

  const tierData = [
    {
      tierName: "Silver Tier",
      discount: "5% Discount",
      consents: [
        {
          name: "Cookie Consent"
        },
        {
          name: "Marketing Consent"
        }
      ]
    },
    {
      tierName: "Gold Tier",
      discount: "Partner coupon",
      consents: [
        {
          name: "Data Sharing Consent"
        },
        {
          name: "Geolocation Consent"
        }
      ]
    },
    {
      tierName: "Platinum Tier",
      discount: "Free Shipping",
      consents: [
        {
          name: "Push Notification Consent"
        },
        {
          name: "Consent for Term of Service"
        },
        {
          name: "Email Marketing Consent"
        }
      ]
    }
  ];
  return (
    <div className="fixed left-0 top-0 z-50 flex size-full items-start justify-center border-grey-DDDFDE bg-grey-35 px-3">
      <div className="relative mt-43px max-w-129 rounded-[10px] bg-white p-6">
        <div className="flex flex-col">
          <div className="font-MontserratSemiBold text-ft22-26.82-0.4 text-black-131426">
            Turn On Rewards
          </div>
          <div className="mt-11px font-PoppinsRegular text-ft15-22.5-0.3 text-grey-575757">
            Do you want to offer discount coupons and rewards to your users in
            exchange for providing their email address for marketing purposes or
            granting various consents?
          </div>
          <div className="mt-2.5 max-w-117">
            {tierData.map((item) => {
              return (
                <div
                  key={item.tierName.toLocaleLowerCase()}
                  className="mt-13px w-full"
                >
                  <div className="flex justify-between rounded-t-md bg-grey-B0B1B2 px-3.5 py-1.5 font-Montserrat text-ft15 font-medium text-white">
                    <span>{item.tierName}</span>
                    <span>{item.discount}</span>
                  </div>
                  <div className="whitespace-nowrap rounded-b-md border border-t-0 border-grey-B0B1B2">
                    {item.consents.map((data, consentIndex) => {
                      return (
                        <div key={data.name.toLocaleLowerCase()}>
                          <div className="pb-3 pl-3 pt-11px font-Montserrat text-ft14-17 text-grey-575757">
                            {data.name}
                          </div>

                          {item.consents.length - 1 !== consentIndex && (
                            <hr className="h-1px w-full border-none bg-grey-B0B1B2" />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="mt-35px flex flex-row justify-between">
            <div>
              <button
                onClick={handleClose}
                className="h-12 w-36 rounded border border-grey-D9D9D9 xs:w-183px"
              >
                <span className="font-MontserratMedium text-ft15-26.25 text-black-000000">
                  Setup Later
                </span>
              </button>
            </div>
            <div>
              <button
                onClick={redirectToRewardScreen}
                className="h-12 w-36 rounded bg-purple-6C36B0 text-white xs:w-183px"
              >
                <span className="font-MontserratMedium text-ft15-26.25">
                  Setup Now
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
RewardPopup.propTypes = {
  handleClose: PropTypes.func.isRequired
};
export default RewardPopup;
